export const GUEST_NAME_MIN = 2;
export const GUEST_NAME_MAX = 24;

export const normalizeGuestName = (raw: string) =>
  (raw || '').replace(/\s+/g, ' ').trim();

/** Returns an error message, or null when the name is acceptable. */
export const validateGuestName = (raw: string): string | null => {
  const name = normalizeGuestName(raw);
  if (name.length < GUEST_NAME_MIN) {
    return `Use at least ${GUEST_NAME_MIN} characters.`;
  }
  if (name.length > GUEST_NAME_MAX) {
    return `Keep it to ${GUEST_NAME_MAX} characters or fewer.`;
  }
  return null;
};

export const MIN_SEATS = 2;
export const MAX_SEATS = 9;

export const clampSeats = (n: number) =>
  Math.min(MAX_SEATS, Math.max(MIN_SEATS, Math.round(Number(n) || MIN_SEATS)));
